// calls/index.js
import io from 'socket.io-client';
import CallService from './CallService';
import { webMedia } from './media/webMedia';
import { callActionsInternal } from './storeGlue';
import { socketPath, wsApi } from '../urlConfig';

const getToken = () => window.localStorage.getItem('token') || null;

const getStoredUserId = () => {
    try {
        const raw = window.localStorage.getItem('user');
        if (!raw) return null;
        const user = JSON.parse(raw);
        return user?._id || user?.id || null;
    } catch (_error) {
        return null;
    }
};

const syncMeId = () => {
    const id = getStoredUserId();
    if (id) window.__ME_ID__ = String(id);
    return id;
};

syncMeId();

const callsUrl = `${wsApi}/calls`;
const callsSocketConfigKey = `${callsUrl}|${socketPath}`;

const existingSocket = window.__CALLS_SOCKET__;
const existingConfigKey = window.__CALLS_SOCKET_CONFIG_KEY__;

if (existingSocket && existingConfigKey !== callsSocketConfigKey) {
    existingSocket.disconnect();
    delete window.__CALLS_SOCKET__;
    delete window.__CALL_SERVICE__;
    delete window.__CALLS_SOCKET_CONFIG_KEY__;
    delete window.__CALL_GLUE_BOUND__;
}

export const callsSocket =
    window.__CALLS_SOCKET__ ||
    io(callsUrl, {
        transports: ['websocket', 'polling'],
        path: socketPath,
        reconnection: true,
        reconnectionAttempts: Infinity,
        reconnectionDelay: 800,
        reconnectionDelayMax: 5000,
        timeout: 15000,
        withCredentials: false,
        auth: {
            token: getToken(),
        },
    });

window.__CALLS_SOCKET__ = callsSocket;
window.__CALLS_SOCKET_CONFIG_KEY__ = callsSocketConfigKey;

callsSocket.on('connect', () => {
    syncMeId();
    const token = getToken();

    if (token) {
        callsSocket.emit('auth:token', { token });
    }

    console.log('[calls] connected', {
        id: callsSocket.id,
        url: callsUrl,
        path: socketPath,
        me: window.__ME_ID__ || null,
    });
});

callsSocket.on('connect_error', (error) => {
    console.warn('[calls] connect_error', error?.message || error);
});

callsSocket.on('disconnect', (reason) => {
    console.log('[calls] disconnected', reason);
});

const defaultIce = [{ urls: 'stun:stun.l.google.com:19302' }];

export const callService =
    window.__CALL_SERVICE__ ||
    new CallService({
        socket: callsSocket,
        media: webMedia,
        iceServers: defaultIce,
    });

window.__CALL_SERVICE__ = callService;

export function bindCallListeners(dispatch, getState) {
    callActionsInternal(callService, dispatch, getState);
}

export function refreshCallsAuth() {
    syncMeId();

    callsSocket.auth = {
        ...(callsSocket.auth || {}),
        token: getToken(),
    };

    if (callsSocket.connected) {
        callsSocket.emit('auth:token', { token: getToken() });
        return;
    }

    callsSocket.connect();
}

Object.defineProperty(window, '__pc', {
    get() {
        return callService?.pc || null;
    },
});